import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper'
import RBButton from '../../controls/RBButton'
import { localize } from '../../util/Localizer'
import { validateFileType } from '../../util/FileValidation'
import FileUploadPreview from './FileUploadPreview'
// import NotificationSystem from 'react-notification-system'
import GenericModal from '../../widgets/common/GenericModal'
import Config from '../../Config'

const photoUpload = 'photoUpload'

class FileUpload extends Component {
  constructor (props) {
    super(props)

    this.handleDragOver = this.handleDragOver.bind(this)
    this.handleFileSelect = this.handleFileSelect.bind(this)
    this.previews = this.previews.bind(this)
    this.selectFile = this.selectFile.bind(this)
    this.validateFileUpload = this.validateFileUpload.bind(this)
    this.renderUpload = this.renderUpload.bind(this)
    this.showFileError = this.showFileError.bind(this)

    this.state = {
      fileList: this.props.initialFileList || [],
      fileUploadErrorMsg: null,
      showGenericModal: false,
      type: photoUpload
    }
  }

  static getDerivedStateFromProps (props, state) {
    const { initialFileList = [] } = props
    const { fileList = [] } = state

    // Only update the file list with the initial
    // files if the file list is still empty:
    if (initialFileList.length > 0 && fileList.length === 0) {
      return {
        fileList: initialFileList
      }
    }

    if (props.type !== photoUpload) {
      return {
        fileList: [],
        type: props.type
      }
    }

    return {
      type: photoUpload
    }
  }

  handleDragOver (e) {
    if ('preventDefault' in e) {
      e.stopPropagation()
      e.preventDefault()
    }
  }

  handleFileSelect (e) {
    this.handleDragOver(e)
    const files = e.target.files || e.dataTransfer.files

    if (files.length > 0) {
      const validFiles = this.validateFileUpload(Array.from(files))

      if (validFiles.length > 0) {
        const { fileList } = this.state
        const newFileList = [...fileList, ...validFiles]
        const uniqueFiles = this.getUniqueFiles(newFileList)
        this.updateFileList(uniqueFiles)
      }

      e.target.value = ''
    }
  }

  validateFileUpload (uploadedFiles) {
    let fileUploadErrorMsg = ''
    const validFiles = []

    if (uploadedFiles.length > Config.maxNoOfFilesToUpload) {
      fileUploadErrorMsg = localize('pages.SubmitAClaim.PhotoUpload.MaxFilesLimitReached').replace('%s', Config.maxNoOfFilesToUpload)
      validFiles.length = 0
    } else {
      uploadedFiles.forEach((file) => {
        if (file.size > Config.maxFileSize) {
          fileUploadErrorMsg += (localize('pages.SubmitAClaim.PhotoUpload.MaxFileSizeLimit').replace(/(%s1)|(%s2)/g, (str, p1, p2) => {
            if (p1) return file.name
            if (p2) return (Number(Config.maxFileSize) / 1048576)
          }) + ' ')
        } else if (!validateFileType(file)) {
          fileUploadErrorMsg += (localize('pages.SubmitAClaim.PhotoUpload.fileTypeError') + ' ')
        } else {
          validFiles.push(file)
        }
      })
    }

    const totalUploadedFiles = Number(validFiles.length) + Number(this.state.fileList.length)
    if (totalUploadedFiles > Config.maxNoOfFilesToUpload) {
      fileUploadErrorMsg = localize('pages.SubmitAClaim.PhotoUpload.MaxFilesLimitReached').replace('%s', Config.maxNoOfFilesToUpload)
      validFiles.length = 0
    }

    this.setState({
      fileUploadErrorMsg,
      showGenericModal: fileUploadErrorMsg.length > 0
    })

    return validFiles
  }

  updateFileList (fileList = []) {
    this.setState({ fileList }, () => {
      if (typeof this.props.onUpdateFileList === 'function') {
        const claimSubmitType = (fileList.length > 0) ? photoUpload : null
        this.props.onUpdateFileList(fileList, claimSubmitType)
      }
    })
  }

  addItem (file) {
    this.updateFileList([ ...this.state.fileList, file ])
  }

  removeItem (e, index) {
    if (e && 'preventDefault' in e) {
      e.stopPropagation()
      e.preventDefault()
    }

    const fileList = [ ...this.state.fileList ]
    fileList.splice(index, 1)

    this.updateFileList(fileList)
  }

  showFileError () {
    const fileError = localize('pages.SubmitAClaim.PhotoUpload.fileTypeError')

    this.setState({
      fileUploadErrorMsg: fileError,
      showGenericModal: fileError.length > 0
    })
  }

  previews () {
    const files = this.getUniqueFiles(this.state.fileList)
    return files.map((file, index) => {
      return (
        <Col key={index} xs={12}>
          <FileUploadPreview key={index}
            data={file}
            onSelectFile={file => this.addItem(file)}
            onRemove={(e) => this.removeItem(e, index)}
            returnMessage={this.showFileError}
          />
        </Col>
      )
    })
  }

  selectFile (e) {
    e.preventDefault()
    this.input.click(e)
  }

  getUniqueFiles (files) {
    return files.reduce((x, y) => {
      if (x.findIndex(e => e.name === y.name) < 0) {
        return [...x, y]
      } else {
        return x
      }
    }, [])
  }

  renderPreview () {
    return (
      <Row style={{ display: this.state.fileList.length > 0 ? 'block' : 'none' }} className='image-preview-row'>
        <Col xs={12}>
          <Row start='xs'>
            <Col xs={12}>
              <p className='progressbar-title'>{localize('pages.SubmitAClaim.PhotoUpload.Files')}</p>
            </Col>
          </Row>
          <Row style={{ marginBottom: '10px' }}>
            {this.previews()}
          </Row>
          {this.state.showGenericModal
            ? <Row>
              <Col xs={12}>
                <GenericModal
                  open={this.state.showGenericModal}
                  handleClose={() => this.setState({ showGenericModal: false })}
                  modal
                  message={this.state.fileUploadErrorMsg}
                  style={{ minWidth: 300 }}
                />
              </Col>
            </Row> : null}
        </Col>
      </Row>
    )
  }

  renderUpload () {
    const props = this.props
    const isSelected = props.type === 'photoUpload'
    const photoSubmitTypeClass = isSelected ? { className: 'submissionTypePhotoSelected', elevation: 3 } : { className: 'submissionTypePhotoBox', elevation: 1 }
    const textToBold = localize('pages.SubmitAClaim.PhotoUpload.UploadImages.BoldText')
    const [firstPart, secondPart] = localize('pages.SubmitAClaim.PhotoUpload.UploadImages').split(textToBold)
    const { renderPreviewBeforeInput = false } = props

    if (this.props.emptyState) {
      return (
        <div style={{ fontWeight: 300, fontSize: '1rem' }}>
          <Row center='xs' middle='xs' className='boxRow'>
            <Col>
              <p style={{ fontWeight: 500, fontSize: '1rem', textTransform: 'capitalize' }}>{props.hasCOB ? localize('pages.SubmitAClaim.PhotoUpload.UploadPhotoOfYourReceiptAndEOB') : localize('pages.SubmitAClaim.PhotoUpload.UploadPhotoOfYourReceipt')}</p>
              <p>
                <i className='fa fa-file-image-o fa-4x' aria-hidden='true' style={isSelected ? null : { fontSize: 80 }} />
              </p>
              <p style={{ fontSize: '0.77rem' }}>{firstPart}<span className='bold'>{localize('pages.SubmitAClaim.PhotoUpload.UploadImages.BoldText')}</span>{secondPart}</p>
              { (renderPreviewBeforeInput) && this.renderPreview() }
              <RBButton
                variant='contained'
                styles={{ minWidth: 240 }}
                primary
                containerElement='label'
                label={localize('pages.SubmitAClaim.PhotoUpload.BrowseFilesButton')}
                onClick={this.selectFile}
              />
            </Col>
            <input type='file' style={{ display: 'none' }}
              ref={(x) => { this.input = x }}
              onChange={this.handleFileSelect}
              multiple={props.multiple}
              size={props.fileSize} />
          </Row>
          { (!renderPreviewBeforeInput) && this.renderPreview() }
        </div>
      )
    } else {
      return (
        <Paper {...photoSubmitTypeClass}>
          <Row center='xs' middle='xs' className='boxRow'>
            <Col>
              <p>
                <i className='fa fa-file-image-o fa-4x' aria-hidden='true' />
              </p>
              <p>{props.hasCOB ? localize('pages.SubmitAClaim.PhotoUpload.UploadPhotoOfYourReceiptAndEOB') : localize('pages.SubmitAClaim.PhotoUpload.UploadPhotoOfYourReceipt')}</p>
              { (renderPreviewBeforeInput) && this.renderPreview() }
              <RBButton
                variant={isSelected ? 'outlined' : 'contained'}
                styles={isSelected ? { background: 'white' } : null}
                primary={!isSelected}
                color={!!isSelected}
                containerElement='label'
                label={localize('pages.SubmitAClaim.PhotoUpload.BrowseFilesButton')}
                onClick={this.selectFile} />
            </Col>
            <input type='file' style={{ display: 'none' }}
              ref={(x) => { this.input = x }}
              onChange={this.handleFileSelect}
              multiple={props.multiple}
              size={props.fileSize} />
          </Row>
          { (!renderPreviewBeforeInput) && this.renderPreview() }
        </Paper>
      )
    }
  }

  render () {
    // const isSelected = this.state.fileList.length > 0
    return (
      <Row> {/* className={isSelected > 0 && this.props.emptyState ? 'submissionTypePhotoBoxSection' : null}> */}
        <Col xs={12}>
          {this.renderUpload()}
        </Col>
      </Row>
    )
  }
}

export default FileUpload



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/FileUpload.js